export default __webpack_public_path__ + "static/media/ic-part-test.b15f4766.svg";